import moment from 'moment';
import Base from './Base';

export default class CalendarEvent extends Base {
    constructor(props, children = []) {
        super();
        this.import(props, children);
    }

    import(props) {
        if (!props) {
            props = {}
        }

        if (typeof props === 'number') {
            this.id = props;
            return;
        }

        this.id = this.assign('id', props);
        this.title = this.assign('title', props);
        this.description = this.assign('description', props);
        this.rules = this.assign('rules', props);
        this.prizes = this.assign('prizes', props);
        this.start = props.start ? moment(props.start).toDate() : null;
        this.end = props.end ? moment(props.end).toDate() : null;
        this.type = this.assign('type', props);
        this.subtype = this.assign('subtype', props);
        this.capacity = this.assign('capacity', props);
        this.location = this.assign('location', props);
        this.price = this.assign('price', props);
        this.imageLogo = this.assign('imageLogo', props);
        this.imageCalendarBackground = this.assign('imageCalendarBackground', props);
        this.imageWideBackground = this.assign('imageWideBackground', props);
        this.status = this.assign('status', props) || null;
        this.platformEventId = this.assign('platformEventId', props);
        this.stockOperationId = this.assign('stockOperationId', props) || null;
        this.revision = this.assign('revision', props) || 1;

        // Helper property - event is finalized when status is 'finalized'
        this.finalized = this.status === 'finalized';
        this.reservations = this.assign('reservations', props) || [];
        this.consumables = this.assign('consumables', props) || [];
        this.createdAt = props.createdAt ? moment(props.createdAt) : this.createdAt;
        this.updatedAt = props.updatedAt ? moment(props.updatedAt) : this.updatedAt;
    }

    export() {
        const data = {
            id: this.id,
            title: this.title,
            description: this.description,
            rules: this.rules,
            prizes: this.prizes,
            start: this.start,
            end: this.end,
            type: this.type,
            subtype: this.subtype,
            capacity: this.capacity,
            location: this.location,
            price: this.price,
            imageLogo: this.imageLogo,
            imageCalendarBackground: this.imageCalendarBackground,
            imageWideBackground: this.imageWideBackground,
            platformEventId: this.platformEventId
        };
        
        // Only include status if explicitly set
        if (this.status) {
            data.status = this.status;
        }
        
        return data;
    }
}
